import classNames from 'classnames';
import { Grid } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import React from 'react';
import { translate } from 'react-i18next';
import PriceTag from './PriceTag';

const styles = theme => ({

    pvp: {
        color: theme.palette.primary.contrastText,
        background: '#000000', // No lo llevo al Theme porque es el único lugar donde se usa.
    },
});

class ResultCardPrice extends React.Component {

    render() {
        const { B2bVerPVP, pvp, price, showPvpIcon, classes } = this.props;
        return (
            <Grid container className={'roomRow'} item xs={2}>            
                {/*
                    PRICE
                */}
                <Grid item xs={showPvpIcon ? 6 : 12} >
                    <PriceTag
                        B2bVerPVP={B2bVerPVP}
                        pvp={pvp}
                        price={price}
                        showNetPrice={showPvpIcon}
                    />
                 {/*
                    PVP
                */}
                {
                    showPvpIcon ?
                            <div className={classNames('circle', classes.pvp)}>PVP</div>
                        : ''
                }
                </Grid>
            </Grid>);
    }
}

export default translate('translations')(withStyles(styles)(ResultCardPrice));


// WEBPACK FOOTER //
// ./src/components/Results/ResultCardPrice.js